// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2oKen","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2ZETj"};